import { Box, Button, ButtonProps } from '@chakra-ui/react';
import React from 'react';

const Indicator: React.FC = () => {
  return (
    <Box
      position="absolute"
      width="7px"
      height="7px"
      background="#6e6e71"
      borderRadius="7px"
      left="0"
      top="15px"
    />
  );
};

interface LanguageButtonProps extends ButtonProps {
  selected?: boolean;
}

const LanguageButton: React.FC<LanguageButtonProps> = ({
  selected,
  children,
  ...props
}) => {
  return (
    <Button
      color="#6e6e71"
      fontSize="16px"
      fontFamily="ProximaNova"
      fontWeight="600"
      background="transparent"
      display="block"
      textAlign="left"
      padding="8px 20px"
      transition="0.3s"
      position="relative"
      _hover={{
        color: '#181818',
        background: 'transparent'
      }}
      _disabled={{
        background: 'transparent',
        color: '#cbcbcb'
      }}
      _active={{
        background: 'transparent'
      }}
      _focus={{
        outline: 'none'
      }}
      {...props}
    >
      {selected && <Indicator />}
      {children}
    </Button>
  );
};

export default LanguageButton;
